module.exports = __webpack_public_path__ + "media/images/flf-flower_half-35bd91ebec70fd8f3bb98e4e11ca010f.jpg";